cobalt-banner {
  display: block;
}

cobalt-banner .core-banner {
  box-shadow: var(--effect-drop-none);
}

cobalt-banner .core-banner .banner-content {
  padding: var(--number-spacing-3xsmall);
}

cobalt-banner .core-banner .banner-content .icon-box {
  padding: var(--number-spacing-none);
}
